import { Dialog } from '@headlessui/react';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface LockNoticeProps {
  open: boolean;
  onClose: () => void;
}

export function LockNotice({ open, onClose }: LockNoticeProps) {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      className="relative z-50"
    >
      <div className="fixed inset-0 bg-red-500/15" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-md w-full rounded-xl bg-white shadow-xl border border-red-300 p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-3 rounded-full bg-red-100">
              <Lock className="h-6 w-6 text-red-600" />
            </div>
            <Dialog.Title className="text-xl font-extrabold text-red-700">
              Stock Refill Mode
            </Dialog.Title>
          </div>

          <Dialog.Description className="text-gray-700 mb-6 space-y-2">
            <p>
              We are currently locking new checkout orders because we are restocking inventory and validating availability.
            </p>
            <p className="font-semibold text-red-700">Please check again in a few minutes.</p>
          </Dialog.Description>

          <div className="flex justify-end">
            <Button onClick={onClose} className="bg-red-600 hover:bg-red-700 text-white">
              Close
            </Button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}